import Splide from '@splidejs/splide';

export default class Slider {
	static init() {
		Array.from(document.querySelectorAll('.slider')).forEach(element => {
			new Slider(element);
		});
	}

	constructor(element) {
        if (!element) return;
        this.options = JSON.parse(element.dataset.options);
        if (!this.options) return;

        switch(document.documentElement.lang) {
            case 'de':
                this.options.i18n = {
                    prev: 'Vorheriger Artikel',
                    next: 'Nächster Artikel',
                    first: 'Gehe zum ersten Artikel',
                    last: 'Gehe zum letzten Artikel',
                    slideX: 'Gehe zu Artikel %s',
                    pageX: 'Gehe zu Seite %s',
                    play: 'Autoplay starten',
                    pause: 'Autoplay pausieren',
                }
                break;
            case 'it':
                this.options.i18n = {
                    prev: 'Articolo precedente',
                    next: 'Prossimo articolo',
                    first: 'Vai al primo articolo',
                    last: 'Vai all\'ultimo articolo',
                    slideX: 'Vai all\'articolo %s',
                    pageX: 'Vai alla pagina %s',
                    play: 'Avvia autoplay',
                    pause: 'Metti in pausa autoplay',
                }
                break;
            default:
                this.options.i18n = {
                    prev: 'Previous article',
                    next: 'Next article',
                    first: 'Go to first article',
                    last: 'Go to last article',
                    slideX: 'Go to article %s',
                    pageX: 'Go to page %s',
                    play: 'Start autoplay',
                    pause: 'Pause autoplay',
                };
        }

		this.slider = new Splide(element.querySelector('.splide'), this.options).mount();

        if (document.body.classList.contains('neos-backend')) {
            document.addEventListener('Neos.NodeSelected', (event) => {
                const element = event.detail.element;
                if (!element) {
                    return;
                }

                const slideIndex = element.dataset.index;
                if (!slideIndex) {
                    return;
                }

                this.slider.go(parseInt(slideIndex));
            }, false);
        }
	}
}
